<div
    class="sc-header sc-header-margin"
    id="sc-header"
    #scHeaderContainer
>
    <div class="sc-header-main">
        <div class="sc-header--user-info">
            <cmps-user-info
                [username]="
                    state?.selectedTab?.user?.firstName +
                    ' ' +
                    state?.selectedTab?.user?.lastName
                "
                usernameDisplay="label"
            >
                <ng-template cmpsUserInfoLabels>
                    <div
                        cmpsUserInfoLabel
                        *ngIf="!_headerCollapsed"
                    >
                        <span
                            >{{
                                _i18n._804_SUPERGROUP_ | translate
                            }}&nbsp;</span
                        >
                        <span>{{ state?.selectedTab?.user?.superGroup }}</span>
                    </div>
                    <div cmpsUserInfoLabel>
                        <span>{{ _i18n._9368_ID | translate }}:&nbsp;</span>
                        <span>{{ state?.selectedTab?.user?.id }}</span>
                    </div>
                </ng-template>
            </cmps-user-info>
        </div>

        <cmps-sc-performers
            [isCollapsed]="_headerCollapsed"
            [tabs]="state?.tabs"
            [tab]="state?.selectedTab"
            [useLiveData]="useLiveData"
            (tabChange)="_onTabChange($event)"
            (tabClose)="_onTabClose($event)"
            (addUser)="_onSelectUserClick()"
            (exportScorecard)="_onExportScorecard()"
            (toggleUseLiveData)="_onToggleUseLiveData($event)"
        ></cmps-sc-performers>
    </div>

    <button
        class="cmps-icon-button--sm cmps-icon-button--no-bg sc-header--toggle-expand"
        cmpsIconButton
        [cmpsTooltipTrigger]="
            _headerCollapsed
                ? (_i18n._9977_EXPAND | translate)
                : (_i18n._9978_COLLAPSE | translate)
        "
        trigger="hover"
        (click)="_onToggleExpandClick()"
    >
        <cmps-icon
            [class.sc-toggle-expand--c2e]="!_headerCollapsed"
            [class.sc-toggle-expand--e2c]="_headerCollapsed"
            svgIcon="chevron-down"
        ></cmps-icon>
    </button>
</div>
